module.exports = __webpack_public_path__ + "static/media/blogs_image.52320b8c.svg";